import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import {
  ShowThisField,
  LabelInput,
  LabelTextArea,
  PageBreakAfterToggle,
  MobileVisible,
  PlaceValueIn,
} from './shared'
import { Input } from 'components/Input/Input'
import { validateWholeInteger } from 'apps/builder/lib/input-validation'
import { FieldMaskSetting } from 'apps/builder/components/settings/modal/shared'


export const BarcodeMoreSettings = entry => {
  const entryPDF = {
    showThisFieldType: 'pdf',
    ...entry,
  }

  const entryWeb = {
    showThisFieldType: 'web',
    ...entry,
  }

  const entryExportLabel = {
    labelType: 'export',
    ...entry,
  }

  const entryReceiptLabel = {
    labelType: 'receipt',
    ...entry,
  }

  return (
    <>
      <div className="settings--row">
        <div className="checkbox-labels-wrapper">
          <MaxCharacterLength {...entry} />
          <FieldMaskSetting {...entry} />
        </div>
      </div>

      <div className="settings--row no-border no-bottom">
        <div className="show-this-field-wrapper">
          <label className="settings--label">Visibility</label>
          <ShowThisField {...entryPDF} />
          <ShowThisField {...entryWeb} />
        </div>
        <div className="toggles-group">
          <div className="toggle-wrapper">
            <PageBreakAfterToggle {...entry} />
          </div>
          <div className="toggle-wrapper">
            <MobileVisible {...entry} />
          </div>
        </div>
      </div>

      <div className="settings--row no-top">
        <div className="show-this-field-wrapper">
          <label className="settings--label">Place value in:</label>
          <PlaceValueIn {...entry} />
        </div>
      </div>

      <label className="settings--label">Labels</label>
      <div className="checkbox-labels-wrapper">
        <LabelInput {...entryExportLabel} />
        <LabelInput {...entryReceiptLabel} />
      </div>
      <LabelTextArea {...entry} />
    </>
  )
}

const MaxCharacterLength = ({ guid, length }) => {
  const dispatch = useDispatch()
  const updateMaxLength = value => {
    dispatch(
      updateEntry({
        guid,
        length: value,
      })
    )
  }
  const [valid, validate] = useState(true)
  const validateValue = value => {
    const validation = validateWholeInteger(value)
    validation ? validate(true) : validate(false)
    return validation
  }
  const change = input => {
    const isValid = validateValue(input)
    isValid ? updateMaxLength(input) : ''
  }
  const inputProps = {
    value: length,
    placeholder: ' ',
    id: `${guid}-max-length`,
    update: change,
    label: `Max Character Length`,
    additionalClass: 'settings--inputs',
    maxLength: 3,
    error: !valid,
    errorText: 'Entered value is not a valid number',
  }

  return (
    <div className="checkbox-label">
      <Input {...inputProps} />
    </div>
  )
}
